import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/featureGroup/license.featureGroup.query.gql"
import type {
  FeatureGroupsQuery,
  FeatureGroupsQueryVariables,
} from "@/v2-backoffice-client/license/featureGroup/__types__/license.featureGroup.query"

type Options = QueryHookOptions<FeatureGroupsQuery, FeatureGroupsQueryVariables>

export function useFeatureGroupsQuery(options?: Options) {
  return useQuery<FeatureGroupsQuery, FeatureGroupsQueryVariables>(
    query,
    options,
  )
}
